import { createFileRoute } from "@tanstack/react-router";

import { SiteShell } from "@/components/marketing/site-shell";
import { Landing } from "@/components/marketing/landing";
import { ErrorBoundary } from "@/components/error-boundary";

const TITLE = "ArosFlow — Done-with-you acquisition workflow implementation";
const DESC =
  "Turn your acquisition process into a repeatable lead-to-offer workflow. ArosFlow implementation engagements are $2,500 or $5,000 one-time; software terms are quoted separately.";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <SiteShell>
      <ErrorBoundary label="Home page crashed">
        <Landing />
      </ErrorBoundary>
    </SiteShell>
  );
}
